import { HStack, Text, Th } from "@chakra-ui/react";
import { ChevronDown, ChevronUp } from "react-feather";

export const ThOrder = ({ header, field, ordering, updateOrdering, w = null }) => {
  return (
    <Th onClick={() => updateOrdering(field)} w={w}>
      <HStack>
        <Text m={"0"}>{header}</Text>
        {ordering === `-${field}` && <ChevronDown />}
        {ordering === field && <ChevronUp />}
      </HStack>
    </Th>
  );
};